import { AutoComplete, Button, Form, Input, Select, Spin, Switch } from "antd";
import axios from "axios";
import { debounce } from "lodash";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { getParamValue, jcTypeArray } from "../../utils";
import { authenticateToken } from "../../utils/auth";
import { responseNotification } from "../../utils/notify";
import { useHistory, useLocation, useParams } from "react-router";
import { Link } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
import ShopHeader from "./Layout/topHeader";
import { regions } from "../common/Region";
import ImageUploader from "../FileManager/upload";
import MapBox from "../common/MapBox";
const { TextArea } = Input;
const { Option } = Select;

const AddShop = ({ shopId }: any) => {
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const [freeDelivery, setFreeDelivery] = useState(false);
  const [type, setType] = useState<any>();
  const [limit, setLimit] = useState(16);
  const [key, setKey] = useState("");
  const [merchantId, setMerchantId] = useState();
  const [shopData, setShopData] = useState({ loading: false, data: null });
  const [hubOptions, setHubOptions] = useState({ loading: false, list: [] });
  const [merchantOptions, setMerchantOptions] = useState({
    loading: false,
    list: [],
  });
  const [singleMerchanrInfo, setSingleMerchantInfo] = useState({
    loading: false,
    data: null,
  });

  const [logoUrl, setLogoUrl] = useState<string>();
  const [bannerUrl, setBannerUrl] = useState<string>();

  const [startUpload, setStartUpload] = useState<
    "Initiated" | "Uploading" | "Uploaded"
  >(undefined);
  const [startUpload2, setStartUpload2] = useState<
    "Initiated" | "Uploading" | "Uploaded"
  >(undefined);

  const fetchRef = useRef(null);
  const route = useParams();
  const history = useHistory();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [geoAddress, setGeoAddress] = useState({
    loading: false,
    data: null,
  });

  const [locationOptions, setLocationOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [locationListOptions, setLocationListOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [currentLocation, setCurrentLocation] = useState({
    lat: 23.77340239600077,
    lng: 90.41329051290532,
  });
  // **************************************

  // **************************************
  const getLocationOptions = useCallback(async (key?: string) => {
    setLocationOptions({ loading: true, list: [] });
    const encodedUri = `${process.env.REACT_APP_MAP_API}`;
    const res = await axios.get(
      `${encodedUri}/autocomplete` + (key ? `?key=${key}` : ``),
      {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
        },
      }
    );

    setLocationOptions({
      loading: false,
      list: res?.data?.places,
    });
    setLocationListOptions({
      loading: false,
      list: res?.data?.places?.map((place) => {
        return {
          value: place?.address,
          label: place?.address,
        };
      }),
    });
  }, []);

  const fetchMerchantDetails = useCallback((getMerchantId) => {
    if (getMerchantId) {
      try {
        setSingleMerchantInfo({ loading: true, data: undefined });
        axios
          .get(
            `${process.env.REACT_APP_CATALOG_READER_API}/merchant/details?merchantId=${getMerchantId}`,
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              setSingleMerchantInfo({
                loading: false,
                data: data?.data?.merchant,
              });
            } else {
              setSingleMerchantInfo({ loading: false, data: null });
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            setSingleMerchantInfo({ loading: false, data: null });

            console.log(err);
          });
      } catch (error) {
        setSingleMerchantInfo({ loading: false, data: null });

        console.log(error, "error");
      }
    }
  }, []);

  useEffect(() => {
    if (startUpload === "Uploaded" && startUpload2 === "Uploaded") {
      form?.submit();
    }
  }, [form, startUpload, startUpload2]);

  const onSubmit = async (data) => {
    if (logoUrl || bannerUrl) {
      setLoading(true);

      const readyData = data && {
        address: data.address,
        hubId: data.hubId,
        merchantId: data.merchantId,
        area: data.area,
        // bankInfo: {
        //   accountName: data.accountName,
        //   accountNumber: data.accountNumber,
        //   bankName: data.bankName,
        //   branchName: data.branchName,
        //   routingNumber: data.routingNumber,
        //   swiftCode: data.swiftCode,
        // },
        logo: logoUrl || data.logo,
        banner: bannerUrl || data.banner,
        baseDeliveryCharge: data.baseDeliveryCharge * 1,
        city: data.city,
        contactNumber: `+88${data?.contactNumber}`,
        mobileNumber: `+88${data?.mobileNumber}`,
        country: data.country,
        email: data.email,
        location: {
          latitude: data.latitude * 1,
          longitude: data.longitude * 1,
        },
        displayOrder: parseInt(data.displayOrder),
        description: data.description,
        keywords: data.keywords,
        isFreeDelivery: data.isFreeDelivery || false,
        prepareTime: data.prepareTime * 1,
        name: data.name,
        status: data.status,
        type: data.type,
        minimumAmountForFreeDelivery: freeDelivery
          ? null
          : parseInt(data.minimumAmountForFreeDelivery),
      };

      if (shopData.data) {
        await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/shop`, {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...readyData,
            id: !shopData?.data?.hub?.id && shopData?.data?.id,
          }),
        })
          .then((res) => res.json())
          .then((res) => {
            setLoading(false);

            if (res.statusCode === 200) {
              responseNotification("Shop Updated Successfully", "success");
              form.resetFields();
              history.goBack();
            } else if (res.status === 500) {
              responseNotification("Internal server error", "error");
            } else {
              responseNotification(res.message || "something wrong", "warning");
            }
          })
          .catch((err) => {
            setLoading(false);
            responseNotification(`${"Internal server error"} ${err}`, "error");
            console.error("err", err);
          });
      } else {
        await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/shop`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(readyData),
        })
          .then((res) => res.json())
          .then((res) => {
            setLoading(false);

            if (res.statusCode === 200) {
              responseNotification("Shop Create Successfully", "success");
              form.resetFields();
              history.goBack();
            } else if (res.status === 500) {
              responseNotification("Internal server error", "error");
            } else {
              responseNotification(res.message || "something wrong", "warning");
            }
          })
          .catch((err) => {
            setLoading(false);
            responseNotification(`${"Internal server error"} ${err}`, "error");
            console.error("err", err);
          });
      }
    } else {
      responseNotification(`Product Thumbnail & Image required`, "error");
    }
  };

  const getMerchantOptions = useCallback(
    async (key?: string) => {
      setMerchantOptions({ loading: true, list: null });
      const encodedUri = `${process.env.REACT_APP_RIDER_API}`;
      return axios
        .get(
          `${encodedUri}/admin/merchant/all` +
            `?page=${page || 0}` +
            (limit ? `&limit=${limit || 16}` : ``) +
            (type ? `&serviceType=${type}` : ``) +
            (key ? `&name=${key}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((res) => {
          setMerchantOptions({
            loading: false,
            list: res.data?.merchants?.map((merchant) => ({
              label: merchant.fullName || merchant.mobileNumber?.split("+88"),
              value: merchant.id,
            })),
          });
        })
        .catch((err) => {
          setMerchantOptions({ loading: false, list: [] });
          console.error("Categories: Error", err);
        });
    },
    [limit, page, type]
  );

  const getHubOptions = useCallback(async (key?: string) => {
    setHubOptions({ loading: true, list: [] });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    const res = await axios.get(
      `${encodedUri}/hub/search?page=0&limit=20` + (key ? `&key=${key}` : ``),
      {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
        },
      }
    );

    setHubOptions({
      loading: false,
      list: res?.data?.hub?.map((hub) => {
        return {
          value: hub?.id,
          label: hub?.name,
        };
      }),
    });
  }, []);

  const fetchGeoAddress = useCallback(() => {
    try {
      setGeoAddress({ loading: true, data: undefined });
      axios
        .get(
          `${process.env.REACT_APP_MAP_API}/geocode?latitude=${currentLocation?.lat}&longitude=${currentLocation?.lng}`,
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((data) => {
          if (data.status === 200) {
            setGeoAddress({
              loading: false,
              data: data?.data?.place,
            });
          } else {
            setGeoAddress({ loading: false, data: null });
            responseNotification(
              data.statusText || "something went wrong",
              "error"
            );
          }
        })
        .catch((err) => {
          setGeoAddress({ loading: false, data: null });

          console.log(err);
        });
    } catch (error) {
      setGeoAddress({ loading: false, data: null });
      console.log(error, "error");
    }
  }, [currentLocation?.lat, currentLocation?.lng]);

  const fetchShopDetails = useCallback((getShopId) => {
    if (getShopId) {
      try {
        setShopData({ loading: true, data: undefined });
        axios
          .get(
            `${process.env.REACT_APP_CATALOG_READER_API}/shop/details?shopId=${getShopId}`,
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              const obj = {};
              Object.keys(data?.data?.shop).map((key) => {
                if (
                  key === "createdBy" ||
                  key === "updatedBy" ||
                  key === "hub" ||
                  key === "merchant"
                )
                  return;
                const item = data.data.shop?.[key];

                if (item && typeof item === "object") {
                  if (key === "location") {
                    obj["latitude"] = item?.y;
                    obj["longitude"] = item?.x;
                  } else {
                    Object.keys(item).map((key) => {
                      if (key !== "type") {
                        const itemNested = item?.[key];
                        obj[key] = itemNested;
                      }
                    });
                  }
                }
                obj[key] = item;
              });

              setShopData({
                loading: false,
                data: obj,
              });

              setLogoUrl(data?.data?.shop?.logo);
              setBannerUrl(data?.data?.shop?.banner);
            } else {
              setShopData({ loading: false, data: null });
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })

          .catch((err) => {
            setShopData({ loading: false, data: null });

            console.log(err);
          });
      } catch (error) {
        setShopData({ loading: false, data: null });

        console.log(error, "error");
      }
    }
  }, []);

  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }

      if (value) {
        if (field === "hub") getHubOptions(value);
        else if (field === "merchant") getMerchantOptions(value);
        else if (field === "locations") getLocationOptions(value);
      }
    };

    return debounce(loadOptions, 800);
  }, [getHubOptions, getLocationOptions, getMerchantOptions]);

  useEffect(() => {
    fetchShopDetails((route as any)?.shopId);
  }, [fetchShopDetails, route]);

  useEffect(() => {
    fetchMerchantDetails(merchantId);
  }, [fetchMerchantDetails, merchantId]);

  useEffect(() => {
    if (shopId) {
      fetchShopDetails(shopId);
    }
  }, [fetchShopDetails, form, shopId]);

  useEffect(() => {
    if (key) {
      getLocationOptions();
    }
  }, [getLocationOptions, key]);

  useEffect(() => {
    if (type) {
      getMerchantOptions();
    }
  }, [type]);

  useEffect(() => {
    getMerchantOptions();
    getHubOptions();
  }, [getHubOptions, getMerchantOptions]);

  useEffect(() => {
    if (shopData.data) {
      form.resetFields(Object.keys(shopData.data as any));
      setFreeDelivery(shopData?.data?.isFreeDelivery || false);
      setLogoUrl(shopData.data?.logo);
      setBannerUrl(shopData.data?.banner);
      setCurrentLocation({
        lat: shopData?.data?.location?.y,
        lng: shopData?.data?.location?.x,
      });
    }
  }, [form, shopData]);

  useEffect(() => {
    if (
      shopData?.data &&
      currentLocation.lat !== shopData?.data?.location?.y &&
      currentLocation.lng !== shopData?.data?.location?.x
    ) {
      fetchGeoAddress();
    }
  }, [fetchGeoAddress, currentLocation]);

  const resetData = () => {
    // form?.resetFields();
    setType("");
    setLogoUrl(undefined);
    setBannerUrl(undefined);
    setStartUpload(undefined);
    setStartUpload2(undefined);
  };

  useEffect(() => {
    form.resetFields(["latitude", "longitude", "address"]);
  }, [currentLocation]);

  useEffect(() => {
    form.resetFields(["address"]);
  }, [geoAddress]);

  return (
    <div className="add-product drawer-toggle-wrapper">
      <div className="drawer-toggle-inner-wrapper">
        <div className="bg-white p-3">
          <ShopHeader
            leftarea={
              shopData?.data
                ? `Edit Shop - ${shopData?.data?.name}`
                : "Add Shop"
            }
            rightarea={
              <Link
                to=""
                onClick={(e) => {
                  e.preventDefault();
                  history?.goBack();
                }}
                className="mr-2 text-dark"
              >
                <CloseOutlined />
              </Link>
            }
          />

          <div className="details-area">
            <Form
              name="control-hooks"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              className="ant-form ant-form-vertical"
              onFinish={onSubmit}
              initialValues={{
                ...shopData.data,
                contactNumber: shopData.data?.contactNumber?.replace("+88", ""),
                mobileNumber: merchantId
                  ? singleMerchanrInfo?.data?.mobileNumber?.replace("+88", "")
                  : shopData.data?.mobileNumber?.replace("+88", ""),
                email: merchantId
                  ? singleMerchanrInfo?.data?.email
                  : shopData.data?.email,
                address: geoAddress?.data?.address || shopData.data?.address,
                latitude: currentLocation?.lat,
                longitude: currentLocation?.lng,
              }}
              form={form} // like ref
              layout="vertical"
              autoComplete="off"
            >
              <Form.Item
                hasFeedback
                label="Type"
                rules={[
                  {
                    required: true,
                    message: "Type is required!",
                  },
                ]}
                name="type"
              >
                <Select
                  placeholder="Shop Type"
                  style={{ minWidth: 300 }}
                  onChange={(val) => setType(val)}
                >
                  {Object.values(jcTypeArray)?.map((type, i) => (
                    <Select.Option value={type} key={i}>
                      {type.replace("_", " ")}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item hasFeedback label={`Merchant`} name="merchantId">
                <Select
                  allowClear
                  showSearch
                  placeholder="Select Merchant"
                  optionFilterProp="children"
                  onChange={(val) => setMerchantId(val)}
                  onSearch={(val) => {
                    handleSearch?.(val, "merchant");
                  }}
                  filterOption={(input, option) =>
                    option.children
                      .toString()
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {merchantOptions?.list?.map((merchant) => (
                    <Option value={merchant?.value}>{merchant?.label}</Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                hasFeedback
                label="Shop Name"
                rules={[
                  {
                    required: true,
                    message: "Shop Name is Required!",
                  },
                ]}
                name="name"
              >
                <Input id="name" type="text" placeholder="Enter Shop Name" />
              </Form.Item>

              <Form.Item
                hasFeedback
                label="Email"
                rules={[
                  {
                    required: true,
                    message: "Email is required!",
                  },
                  // { type: 'string', max: 11, min: 11 },
                  {
                    validator: async (_, email) => {
                      if (
                        email &&
                        !String(email)
                          .toLowerCase()
                          ?.match(
                            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                          )
                      ) {
                        return Promise.reject(new Error("Enter valid email"));
                      }
                    },
                  },
                ]}
                name="email"
              >
                <Input id="email" type="email" placeholder="Enter Email" />
              </Form.Item>

              <Form.Item
                hasFeedback
                label="Mobile Number (Login)"
                rules={[
                  {
                    required: true,
                    message: "Mobile Number is required!",
                  },
                  {
                    validator: async (_, names) => {
                      if (!names?.match(/(^(01){1}[3456789]{1}(\d){8})$/)) {
                        return Promise.reject(
                          new Error("Enter valid mobile number")
                        );
                      }
                    },
                  },
                ]}
                name="mobileNumber"
                initialValue={"01"}
              >
                <Input
                  disabled={shopData?.data}
                  id="mobileNumber"
                  type="contact"
                  addonBefore={"+88"}
                  placeholder="Enter Mobile Number"
                />
              </Form.Item>

              <Form.Item
                hasFeedback
                label="Contact Number"
                rules={[
                  {
                    required: true,
                    message: "Contact Number is required!",
                  },
                  {
                    validator: async (_, names) => {
                      if (names?.startsWith("01")) {
                        if (!names?.match(/(^(01){1}[3456789]{1}(\d){8})$/)) {
                          return Promise.reject(
                            new Error("Enter valid contact number")
                          );
                        }
                      } else {
                        if (!names?.match(/[0-9]$/)) {
                          return Promise.reject(
                            new Error("Enter valid contact number")
                          );
                        }
                      }
                    },
                  },
                ]}
                name="contactNumber"
                initialValue={"01"}
              >
                <Input
                  id="contact"
                  type="contact"
                  addonBefore={"+88"}
                  placeholder="Enter Contact Number"
                />
              </Form.Item>

              <Form.Item
                hasFeedback
                label="Activity Status"
                rules={[
                  {
                    required: true,
                    message: "Status is required!",
                  },
                ]}
                name="status"
              >
                <Select
                  placeholder="Select Status"
                  showSearch={true}
                  optionFilterProp="children"
                  allowClear
                >
                  <Select.Option value="Open">Open</Select.Option>
                  <Select.Option value="Busy">Busy</Select.Option>
                  <Select.Option value="Close">Close</Select.Option>
                </Select>
              </Form.Item>

              <Form.Item
                hasFeedback
                label="Prepare Time"
                rules={[
                  {
                    required: true,
                    message: "Prepare Time is Required!",
                  },
                  {
                    validator: async (_, name) => {
                      if (name && !(parseFloat(name) > 0)) {
                        return Promise.reject(
                          new Error("Invalid Delivery Time")
                        );
                      }
                    },
                  },
                ]}
                name="prepareTime"
              >
                <Input id="prepareTime" type="text" />
              </Form.Item>

              <Form.Item
                hasFeedback
                label="Display Order"
                rules={[
                  {
                    required: false,
                    message: "displayOrder is Required!",
                  },
                ]}
                name="displayOrder"
              >
                <Input
                  id="displayOrder"
                  type="text"
                  placeholder="Enter Display Order"
                />
              </Form.Item>

              <Form.Item
                hasFeedback
                label="Free Delivery?"
                name="isFreeDelivery"
                style={{ minWidth: "100%" }}
              >
                <Switch
                  checkedChildren="Yes"
                  unCheckedChildren="No"
                  defaultChecked={shopData?.data?.isFreeDelivery}
                  onChange={setFreeDelivery}
                />
              </Form.Item>

              <Form.Item
                hasFeedback
                label="Base Delivery Charge"
                rules={[
                  {
                    required: true,
                    message: "Delivery Charge is Required!",
                  },
                  {
                    validator: async (_, name) => {
                      if (name && !(parseFloat(name) > 0)) {
                        return Promise.reject(
                          new Error("Invalid Delivery Charge")
                        );
                      }
                    },
                  },
                ]}
                name="baseDeliveryCharge"
              >
                <Input
                  id="baseDeliveryCharge"
                  type="text"
                  placeholder="Enter Delivery Charge"
                />
              </Form.Item>

              {!freeDelivery ? (
                <>
                  <Form.Item
                    hasFeedback
                    label="Minimum Amount For Free Delivery"
                    name="minimumAmountForFreeDelivery"
                    rules={[
                      { required: true, message: "Minimum Amount is Required" },
                    ]}
                  >
                    <Input
                      id="minimumAmountForFreeDelivery"
                      type="text"
                      placeholder="Enter Minimum Amount"
                    />
                  </Form.Item>
                </>
              ) : (
                <div className="" style={{ width: "48%" }}></div>
              )}

              <Form.Item
                hasFeedback
                label="Keywords"
                rules={[
                  {
                    required: true,
                    message: "Keywords is Required!",
                  },
                ]}
                name="keywords"
              >
                <TextArea
                  id="keywords"
                  placeholder="Enter Shop keywords"
                  rows={4}
                />
              </Form.Item>

              <Form.Item
                hasFeedback
                label="Description"
                rules={[
                  {
                    required: true,
                    message: "Description is Required!",
                  },
                ]}
                name="description"
              >
                <TextArea
                  id="description"
                  placeholder="Enter Shop Description"
                  rows={4}
                />
              </Form.Item>

              {/* <h4 className="title" style={{ maxWidth: "99%" }}>
                Bank Information:
              </h4>
              <Form.Item
                hasFeedback
                label="Account Name"
                rules={[
                  {
                    required: true,
                    message: "Account Name is Required!",
                  },
                ]}
                name="accountName"
              >
                <Input
                  id="accountName"
                  type="text"
                  placeholder="Enter Account Name"
                />
              </Form.Item>

              <Form.Item
                hasFeedback
                label="Account Number"
                rules={[
                  {
                    required: true,
                    message: "Account Number is required!",
                  },
                ]}
                name="accountNumber"
              >
                <Input
                  id="accountNumber"
                  type="text"
                  placeholder="Enter Account Number"
                />
              </Form.Item>

              <Form.Item
                hasFeedback
                label="Bank Name"
                rules={[
                  {
                    required: true,
                    message: "Bank Name is Required!",
                  },
                ]}
                name="bankName"
              >
                <Input
                  id="bankName"
                  type="text"
                  placeholder="Enter Bank Name"
                />
              </Form.Item>

              <Form.Item
                hasFeedback
                label="Branch Name"
                rules={[
                  {
                    required: true,
                    message: "Branch Name is Required!",
                  },
                ]}
                name="branchName"
              >
                <Input
                  id="branchName"
                  type="text"
                  placeholder="Enter Branch Name"
                />
              </Form.Item>

              <Form.Item
                hasFeedback
                label="Routing Number"
                rules={[
                  {
                    required: true,
                    message: "Routing Number is Required!",
                  },
                ]}
                name="routingNumber"
              >
                <Input
                  id="routingNumber"
                  type="text"
                  placeholder="Enter Routing Number"
                />
              </Form.Item>

              <Form.Item hasFeedback label="Swift Code" name="swiftCode">
                <Input
                  id="swiftCode"
                  type="text"
                  placeholder="Enter Swift Code"
                />
              </Form.Item> */}

              <h4 className="title" style={{ maxWidth: "99%" }}>
                Location:
              </h4>

              {type === "JC_MART" && (
                <Form.Item hasFeedback label={`Hub`} name="hubId">
                  <Select
                    showSearch
                    placeholder="Select Hub"
                    optionFilterProp="children"
                    onSearch={(val) => {
                      handleSearch?.(val, "hub");
                    }}
                    filterOption={(input, option) =>
                      option.children
                        .toString()
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    disabled={type === "!JC_MART"}
                  >
                    {hubOptions?.list?.map((hub) => (
                      <Option value={hub?.value}>{hub?.label}</Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
              <Form.Item
                hasFeedback
                label="Area"
                rules={[
                  {
                    required: true,
                    message: "Area is required!",
                  },
                ]}
                name="area"
              >
                <Input id="area" type="text" placeholder="Enter shops area" />
              </Form.Item>

              <Form.Item
                hasFeedback
                label="City"
                rules={[
                  {
                    required: true,
                    message: "City is required!",
                  },
                ]}
                name="city"
                initialValue="Dhaka"
              >
                {/* <Input id="city" type="text" placeholder="Enter shops city" /> */}

                <Select
                  showSearch
                  placeholder="Filter by Status"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toString()
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {Object.values(regions.City)?.map((city, i) => (
                    <Select.Option value={city} key={i}>
                      {city}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                hasFeedback
                label="Country"
                rules={[
                  {
                    required: true,
                    message: "Country is required!",
                  },
                ]}
                name="country"
                initialValue="BD"
              >
                <Select
                  id="country"
                  placeholder="Select Country"
                  showSearch={true}
                  optionFilterProp="children"
                  allowClear
                >
                  <Select.Option value="BD">Bangladesh</Select.Option>
                </Select>
              </Form.Item>

              <Form.Item hasFeedback label="Address" name="address">
                <AutoComplete
                  backfill
                  onSearch={(val) => {
                    handleSearch?.(val, "locations");
                  }}
                  options={locationListOptions?.list}
                  defaultActiveFirstOption={false}
                  notFoundContent={
                    locationListOptions?.loading ? <Spin size="small" /> : null
                  }
                  onSelect={(val) => {
                    const matchData = locationOptions?.list?.find(
                      (place) => val === place.address
                    );
                    setCurrentLocation({
                      lat: matchData?.location?.latitude,
                      lng: matchData?.location?.longitude,
                    });
                  }}
                >
                  <Input.Search
                    placeholder="Search by Address"
                    onSearch={(val) => setKey(val)}
                    enterButton={false}
                    loading={locationListOptions.loading}
                  />
                </AutoComplete>
              </Form.Item>

              <Form.Item
                hasFeedback
                label="Latitude"
                name="latitude"
                initialValue={currentLocation?.lat}
              >
                <Input id="latitude" type="text" placeholder="23.86450" />
              </Form.Item>

              <Form.Item
                hasFeedback
                label="Longitude"
                name="longitude"
                initialValue={currentLocation?.lng}
              >
                <Input id="longitude" type="text" placeholder="90.53680" />
              </Form.Item>

              <MapBox
                draggable={true}
                coordinate={currentLocation}
                setCoordinator={(val) => setCurrentLocation(val)}
              />

              <h4 className="title" style={{ maxWidth: "98%" }}>
                Images
              </h4>
              <div className="d-flex">
                <div className="mr-4">
                  <p className="mb-1">Logo</p>
                  <ImageUploader
                    imgUrl={logoUrl || ""}
                    startUpload={startUpload}
                    setStartUpload={(val) => setStartUpload(val)}
                    setGeneratedImgUrl={(url) => setLogoUrl(url)}
                  />
                </div>
                <div className="">
                  <p className="mb-1">Banner:</p>
                  <ImageUploader
                    imgUrl={bannerUrl || ""}
                    startUpload={startUpload}
                    setStartUpload={(val) => setStartUpload2(val)}
                    setGeneratedImgUrl={(url) => setBannerUrl(url)}
                  />
                </div>
              </div>

              <div className="buttons-container">
                <Button
                  disabled={
                    loading ||
                    startUpload === "Uploading" ||
                    startUpload2 === "Uploading"
                  }
                  loading={
                    loading ||
                    startUpload === "Uploading" ||
                    startUpload2 === "Uploading"
                  }
                  type="primary"
                  htmlType="submit"
                  className="add-submit-btn text-center mr-2"
                  onClick={(e) => {
                    e.preventDefault();
                    setStartUpload("Uploading");
                    setStartUpload2("Uploading");
                  }}
                >
                  Submit
                </Button>

                <Button
                  type="ghost"
                  htmlType="button"
                  onClick={resetData}
                  className="reset-submit-btn text-center mr-2"
                >
                  Reset
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddShop;
